import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';

const CryptoJS = require('crypto-js');

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css']
})
export class LoginPageComponent implements OnInit {

  env = environment;
  recaptchaVerified = false;
  encryptionKey :any;

  @ViewChild('captchaRef') captchaRef: any;

  constructor(private apiService : ApiService, private route: ActivatedRoute,private appComponent : AppComponent,
    private router: Router) { }

  ngOnInit(): void {
  }

  login(data : any){
    const formObj = {
      mobile_no: data.mobile_no,
      ulb_id: this.env.ulb_id,
      password: data.password
    }

    formObj.password = CryptoJS.AES.encrypt(formObj.password, this.encryptionKey).toString();
    formObj.mobile_no = CryptoJS.AES.encrypt(formObj.mobile_no, this.encryptionKey).toString();

    this.apiService.postCitizenData(`login`, formObj).subscribe(
      (res: any) => {
        const product = res.data;
        localStorage.setItem('loginDetails', JSON.stringify(res['data']));
        
        const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/user-property-list';
                    this.router.navigateByUrl(returnUrl);
      },
      (error) =>{
        this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
      }
      );

  }

  getEncryptionKey(loginForm: any) {
    if (!this.recaptchaVerified) {
      this.appComponent.showMessageAlert('Please complete the reCAPTCHA verification.', 'error');
      return;
    }
    
    this.apiService.get(`encryption_key`).subscribe(res => {
      this.encryptionKey = res.data.key;

      this.login(loginForm);
      // this.appComponent.hideLoader();
    }, (error) => {

      this.appComponent.showMessageAlert(error.error.error[0].message, 'error');

    });
  }

  disableRightClick(event: MouseEvent) {
    event.preventDefault();
  }

  disableAction(event: ClipboardEvent) {
  event.preventDefault();
}

resolvedRecaptcha(captchaResponse: any) {
  this.recaptchaVerified = false;
  if (captchaResponse) {
    this.apiService.post('verify_recaptcha', {token: captchaResponse}).subscribe(
      (res: any) => {
        if (res.success) {
          this.recaptchaVerified = true;
        } else {
          this.captchaRef.reset();
          this.appComponent.showMessageAlert('reCAPTCHA verification failed. Please try again.', 'error');
        }
      },
      err => {
        console.log(err);
        this.captchaRef.reset();
        this.appComponent.showMessageAlert('reCAPTCHA verification failed. Please try again.', 'error');
      }
    );
  }
}

}
